module.exports = __webpack_public_path__ + "media/error.8e7ba779.mp3";